package com.mps.asc_app.data.places

import io.ktor.client.HttpClient

actual fun createPlacesRepository(httpClient: HttpClient): PlacesRepository =
    PlacesRepositoryJsImpl()